import * as angular from "angular";
import {IController, IWindowService} from "angular";
import * as _ from "lodash";
import {AttachmentsService} from "../../../attachments/services/attachments-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";


export class AttachmentPopupComponent implements IController {
  text: any;
  link: any;
  type: any;
  blobName: any;
  fileName: any;
  extraInfo: any;
  canEdit: boolean;
  metadata: any;
  isTile?: boolean;
  onEdit?: Function;

  public isPdf: boolean;
  public isVideo: boolean;
  public blobNameCopy: any;
  public isTemporaryUrl: any;

  constructor(private $window: IWindowService,
              private attachmentsService: AttachmentsService,
              private commonsDialogService: CommonsDialogService) {
  }

  $onChanges(changes) {
    if (changes.type ||
      (changes.link && !changes.link.isFirstChange()) ||
      (changes.blobName && !changes.blobName.isFirstChange)) {
      if (this.blobName) {
        const blobNameSplitted = this.blobName.split('/');
        this.blobNameCopy = blobNameSplitted[blobNameSplitted.length - 1];
      }
      this.isTemporaryUrl = !this.link || this.link.includes("Expires");
      this.isPdf = (this.type === 'application/pdf' || this.type === '.pdf');
      this.isVideo = (this.type?.includes('video'));
    }
  }

  openPopup(ev) {

    if (this.isTemporaryUrl && this.blobNameCopy) {
      this._getAttachmentByBlobNameUrl(this.blobNameCopy).then((link) => {
        this.commonsDialogService.openPodImagePop(ev, link, this.text, this.extraInfo, this.type)
      })
    } else {
      this.commonsDialogService.openPodImagePop(ev, this.link, this.text, this.extraInfo, this.type)
    }

  }

  download() {
    if (this.isTemporaryUrl && this.blobNameCopy) {
      this._getAttachmentByBlobNameUrl(this.blobNameCopy).then(res => this.$window.location.href = res);
    } else {
      this.$window.location.href = this.link;
    }
  }

  private _getAttachmentByBlobNameUrl(blobName) {
    return this.attachmentsService.getAttachmentsUrls([blobName])
      .then((attachmentsUrls: any[]) => {
        const mapByName = _.mapKeys(attachmentsUrls, (value, key) => {
          return value.name;
        });
        return _.get(mapByName[this.blobNameCopy], 'url');
      });
  }
}

angular
  .module('bringoz.admin.attachments')
  .component('attachmentPopup', {
    bindings: {
      text: '<?',
      link: '<',
      type: '<?',
      blobName: '<?',
      fileName: '<?',
      extraInfo: '<?',
      canEdit: '<?',
      metadata: '<?',
      isTile: '<?',
      onEdit: '&',
    },
    template: require('./attachment-popup.html').default,
    controller: AttachmentPopupComponent
  });

